// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';
import classnames from 'classnames';

// Components
import Button from '../core/button';
import Form from '../core/form';
import InputIde from '../core/input-ide';
import Permissions from '../core/permissions';
import Select from '../core/select';
import SubmitButton from '../core/submit-button';

// Styles
import './rules-form.scss';

function RulesForm(props) {
    const getFieldProps = (fieldName) => ({
        className: 'rules-form--field',
        label: startCase(fieldName),
        name: fieldName,
        validate: ['required'],
    });

    const getResetButtonProps = () => ({
        onClick: resetForm,
        className: 'rules-form--reset',
    });

    const resetForm = (event) => {
        event && event.preventDefault && event.preventDefault();

        const {onReset} = props;

        onReset(false);
    };

    const renderCategory = () => {
        const {editing = true} = props;

        return !editing ? (
            <Select {...getFieldProps('category')}>
                <option value="">Select category...</option>
                <option value="ENRICH">Enrich</option>
                <option value="PRE_PROD">Pre Prod</option>
                <option value="VALIDATION">Validation</option>
            </Select>
        ) : null;
    };

    const renderResetButton = () => {
        const {noReset} = props;

        return !noReset ? <Button {...getResetButtonProps()}>Reset</Button> : null;
    };

    const {className, name, noReset, onReset, readOnly} = props;
    const formProps = {
        className: classnames('rules-form', className),
        fixedPositionedResponse: true,
        name,
        noReset,
        onReset,
        submitData: true,
    };

    return (
        <Form {...formProps}>
            {renderCategory()}
            <Select {...getFieldProps('status')}>
                <option value="">Select status...</option>
                <option value="CURRENT">Current</option>
                <option value="INACTIVE">Inactive</option>
            </Select>
            <InputIde {...getFieldProps('rule')} readOnly={readOnly} />
            {renderResetButton()}
            <Permissions accessRequirement="write">
                <SubmitButton label="Save" />
            </Permissions>
        </Form>
    );
}

RulesForm.propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    name: PropTypes.string.isRequired,
    noReset: PropTypes.bool,
    onReset: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

export default RulesForm;
